import { Form } from 'react-bootstrap';
import CareMapprCheckbox from '../../../../../components/Inputs/checkbox/CareMapprCheckbox';

const checkboxes = [
  { name: 'isViewTime', label: 'View time' },
  { name: 'isViewIcon', label: 'View icon' },
  { name: 'isDrLetterIncluded', label: 'Include Doctor letter' },
  { name: 'isPharmLetterIncluded', label: 'Include Pharmacy letter' },
  { name: 'isLargeFontSize', label: 'Large font size' },
  {
    name: 'isSubheadingIncluded',
    label: 'Include "Subheading" for each medication',
  },
];

const selectOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const ExportSettingsForm = ({ form, canEdit }) => {
  const { watch, setValue, register } = form;
  const onSelectValue = (event) => {
    const { checked, id } = event.target;
    setValue(`pdfOptions.${id}`, checked);
  };

  return (
    <Form.Group className="d-flex flex-wrap gap-1 align-items-center">
      <Form.Label className="me-1 mb-0">Include</Form.Label>
      <Form.Select
        disabled={!canEdit}
        className="w-auto pe-2"
        {...register('pdfOptions.extraRows', { valueAsNumber: true })}
      >
        {selectOptions.map((option) => (
          // how to set value number rather than string?
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
      <Form.Label className="ms-1 mb-0">extra rows in table</Form.Label>
      {checkboxes.map(({ name, label }) => (
        <CareMapprCheckbox
          disabled={!canEdit}
          id={name}
          key={`checkbox-${name}`}
          name={name}
          onChange={onSelectValue}
          label={label}
          checked={watch(`pdfOptions.${name}`)}
        />
      ))}
    </Form.Group>
  );
};

export default ExportSettingsForm;
